import React from 'react';
import styles from './styles/Alert.module.css';

export default function Alert({ type = 'info', message, onClose }) {
    return (
        <div className={`${styles.alert} ${styles[type]}`}>
            <div className={styles.content}>
                <p>{message}</p>
            </div>
            {onClose && (
                <button
                    className={styles.closeBtn}
                    onClick={onClose}
                    aria-label="Fermer"
                >
                    ✕
                </button>
            )}
        </div>
    );
}
